import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, RouterStateSnapshot, UrlTree } from '@angular/router';

// RxJs
import { Observable, pipe } from 'rxjs';
import { map, tap } from 'rxjs/operators';

// services
import { SecurityService } from '@app/core/security/service/security.service';



@Injectable({
  providedIn: 'root'
})
export class AuthenticationGuard implements CanActivate, CanActivateChild {

	constructor(
    private router: Router,
    private securityService: SecurityService
  ) { }


  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean> | boolean {
    return this.securityService.isAuthenticated(next, state, 'canActivate').pipe(this.logInPipes());
  }


	canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean> | boolean {
    return this.securityService.isAuthenticated(childRoute, state, 'canActivateChild').pipe(this.logInPipes());
  }


  private logInPipes(): any {
    return pipe(
      map(isAuthenticared => Boolean(isAuthenticared)),
      // tap((res: boolean) => {!res ? alert('login guard') : alert('cache guard');})
    );
  }
}
